var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.$t('contactFields')))]),_c('custom-fields',{attrs:{"is-output-data":false,"campaign":_vm.campaign,"title":"campaignContactFields"},on:{"save":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }